export default __webpack_public_path__ + "static/media/rocket_anim_66.9b03460c.png";